<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> »音声ファイルダウンロードの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>音声ファイルダウンロードの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/voice-file-download.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Filter
        </div>
        <div class="manual-explain">
          音声ファイルダウンロード一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: カテゴリ、ID、名称、言語
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 音声ファイル一覧
        </div>
        <div class="manual-explain">
          作成済みの音声ファイル一覧が表示されます。<br>
          一覧に表示されるのは、展示や施設、フロア・表示グループの編集画面にある「詳細」で音声作成した時に自動作成される言語ごとの音声ファイルとなります。<br>
          ダウンロードボタンをクリックすることで対象の音声ファイルをダウンロードします。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Voice File Download
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Voice File Download</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_voice-file-download.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the voice file download list.<br>
          *Filtering targets: Category, ID, Name, Language
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Voice File List
        </div>
        <div class="manual-explain">
          Displays a list of created voice files.<br>
          The list shows voice files for each language that are automatically created when voice is generated in the "Detail" section of exhibit, facility, or floor/display group edit screens.<br>
          Click the download button to download the target voice file.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
